
"use client"

import { Button, Col, InputNumber, Row, Select } from "antd"

import Title from "@/components/common/Typography/Title"
import Text from "@/components/common/Typography/Text"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { useTranslation } from "react-i18next"
import _ from "lodash"

const InputChildren = () => {
  const value = useAppSelector(state => state.hotel.formSearch.children || 0)
  const childrenAges = useAppSelector(state => state.hotel.formSearch.childrenAges)
  const isDesktop = useIsDesktop()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const setValue = (val: any) => {
    if (!childrenAges?.length) {
      dispatch(hotelActions.setChildrenAges(Array(val).fill(null).map(() => 0)))
    } else {
      if (childrenAges?.length > val) {
        dispatch(hotelActions.setChildrenAges(childrenAges.slice(0, val)))
      }

      if (childrenAges?.length < val) {
        dispatch(hotelActions.setChildrenAges(
          childrenAges.concat(Array(val - childrenAges.length).fill(null).map(() => 0))
        ))
      }
    }
    dispatch(hotelActions.updateChildren(val))
  }

  return (
    <>
      <Row gutter={[50, 10]} style={{ marginBlock: '1.6rem' }} justify='space-between' align='middle'>
        <Col>
          <Row>
            <Title level={isDesktop ? 4 : 5} style={{ margin: 0 }}>{t("common.child")}</Title>
          </Row>
          <Row>
            <Text type='secondary'>{t("common.child_rule", { min: 0, max: 17 })}</Text>
          </Row>
        </Col>
        <Col>
          <Row align='middle' gutter={[5, 5]}>
            <Col>
              <Button
                disabled={value === 0}
                onClick={() => setValue(value - 1)}
                size='large'
                shape='circle'
                icon={<MinusOutlined />}
              />
            </Col>
            <Col>
              <InputNumber
                min={0}
                onChange={(v) => setValue(v || 0)}
                value={value} variant='borderless'
                controls={false} size='large'
                style={{ maxWidth: 45 }}
              />
            </Col>
            <Col>
              <Button
                onClick={() => setValue(value + 1)}
                size='large'
                shape='circle'
                icon={<PlusOutlined />}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[15, 15]}>
        {Array(value).fill(null).map((___, index) => {
          const v = (childrenAges || [])[index]
          return (
            <Col key={index}>
              <Row align='middle' justify='center' gutter={10} wrap={false}>
                <Col>
                  <Title level={isDesktop ? 4 : 5} style={{ margin: 0 }}>{t("common.child")} {index + 1}</Title>
                </Col>
                <Col>
                  <Select
                    value={v}
                    optionLabelProp="label"
                    onChange={(val) => {
                      const newValue = [...(childrenAges || [])]
                      newValue[index] = val
                      dispatch(hotelActions.setChildrenAges(newValue))
                    }}
                    options={Array(18).fill(null).map((__: any, index1: any) => {
                      return {
                        value: index1,
                        label: index1 === 0 ? `< 1 ${_.lowerFirst(t("common.years_old"))}` : `${index1} ${_.lowerFirst(t("common.years_old"))}`
                      }
                    })}
                  />
                </Col>
              </Row>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default InputChildren